<div class="card">
    <div class="section-header">
        <h2 class="section-title">{{ 'profileSkills.skills' | translate }}</h2>
        <button class="add-btn" (click)="openAddModal()" *ngIf="mode=='edit'">{{ 'profileSkills.add' | translate
            }}</button>
    </div>

    <!-- Skills Tags -->
    <div class="skills-wrap" *ngIf="skills && skills.length > 0">
        <span class="skill-tag" *ngFor="let skill of skills; let i = index">
            {{ skill.skill }}
            <button class="skill-close" *ngIf="mode=='edit'" (click)="deleteSkill(i)"
                [title]="'profileSkills.remove' | translate">×</button>
        </span>
    </div>

    <!-- Empty state -->
    <div *ngIf="!skills || skills.length === 0 && mode=='edit' ">
        <p class="empty-text">
            {{ 'profileSkills.addYourSkills' | translate }}
        </p>
    </div>
    <div *ngIf="!skills || skills.length === 0 && mode=='view'">
        <p class="empty-text">
            {{ 'profileSkills.addYourSkillscompany' | translate }}
        </p>
    </div>
</div>

<!-- Add / Edit Modal — outside .card -->
<div class="modal-overlay" *ngIf="isModalOpen && mode=='edit'" (click)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">

        <button class="close-btn" (click)="closeModal()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>

        <div class="modal-header">
            <h3 class="modal-title">{{ isEditing ? ('profileSkills.editSkill' | translate) : ('profileSkills.addSkill' |
                translate) }}</h3>
        </div>

        <div class="modal-body">
            <form [formGroup]="skillForm">

                <!-- Skill Name -->
                <div class="form-group">
                    <label for="skill">{{ 'profileSkills.skillName' | translate }} <span
                            class="required">*</span></label>
                    <input id="skill" type="text" formControlName="skill" class="form-input"
                        placeholder="e.g. JavaScript, React, Angular, Java, etc." />
                    <span class="field-error"
                        *ngIf="skillForm.get('skill')?.invalid && skillForm.get('skill')?.touched">
                        Required
                    </span>
                </div>

                <!-- Proficiency Percentage -->
                <div class="form-group">
                    <label for="percentage">{{ 'profileSkills.proficiencyLevel' | translate }} <span
                            class="required">*</span></label>
                    <input id="percentage" type="number" formControlName="percentage" class="form-input" min="0"
                        max="100" placeholder="0-100" />
                    <span class="field-error"
                        *ngIf="skillForm.get('percentage')?.invalid && skillForm.get('percentage')?.touched">
                        {{ 'profileSkills.mustBeBetween0_100' | translate }}
                    </span>
                </div>

            </form>

            <div class="modal-actions">
                <button class="btn btn-cancel" (click)="closeModal()">{{ 'profileSkills.cancel' | translate }}</button>
                <button class="btn btn-save" (click)="saveSkill()" [disabled]="isSaving">
                    <span *ngIf="!isSaving">{{ isEditing ? ('profileSkills.saveChanges' | translate) :
                        ('profileSkills.addSkill' | translate) }}</span>
                    <span *ngIf="isSaving">{{ 'profileSkills.saving' | translate }}</span>
                </button>
            </div>
        </div>

    </div>
</div>